import {Heading} from 'platform/foundation';

import {Nullish, TestIdProps} from 'shared/web';

interface FooterHeadingProps extends TestIdProps {
  children: Nullish | string;
}

export function FooterHeading(props: FooterHeadingProps) {
  return (
    <Heading color="secondary" size={4} data-testid={props['data-testid']}>
      {props.children}
    </Heading>
  );
}
